
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {StorageDatabaseType} from './StorageDatabaseType';
import {FieldModelStorageDatabaseType} from './StorageDatabaseType';

/**
 * StorageServerSettings struct
 */
class StorageServerSettings {
  /**
   * Initialize struct
   * @param {!number=} storagePort
   * @param {!StorageDatabaseType=} storageDatabase
   * @param {!string=} storageDatabaseFile
   * @param {!boolean=} useSsl
   * @param {!boolean=} deprecated1
   * @param {!number=} slowQueryLogThreshold
   * @param {!StorageDatabaseType=} archiveDatabase
   * @param {!string=} archiveDatabaseFile
   * @constructor
   */
  constructor (storagePort = 6130, storageDatabase = new StorageDatabaseType(StorageDatabaseType.SQLITE), storageDatabaseFile = '../database/trader.db', useSsl = false, deprecated1 = false, slowQueryLogThreshold = new UInt64(100000000, 0), archiveDatabase = new StorageDatabaseType(StorageDatabaseType.SQLITE), archiveDatabaseFile = '../database/archive.db') {
    this.StoragePort = storagePort
    this.StorageDatabase = storageDatabase
    this.StorageDatabaseFile = storageDatabaseFile
    this.UseSsl = useSsl
    this.Deprecated1 = deprecated1
    this.SlowQueryLogThreshold = slowQueryLogThreshold
    this.ArchiveDatabase = archiveDatabase
    this.ArchiveDatabaseFile = archiveDatabaseFile
  }

  /**
   * Copy struct (shallow copy)
   * @this {!StorageServerSettings}
   * @param {!StorageServerSettings} other Other struct
   * @returns {!StorageServerSettings} This struct
   */
  copy (other) {
    if (other.StoragePort != null) {
      this.StoragePort = other.StoragePort
    } else {
      this.StoragePort = null
    }
    if (other.StorageDatabase != null) {
      this.StorageDatabase = StorageDatabaseType.fromObject(other.StorageDatabase)
    } else {
      this.StorageDatabase = null
    }
    if (other.StorageDatabaseFile != null) {
      this.StorageDatabaseFile = other.StorageDatabaseFile
    } else {
      this.StorageDatabaseFile = null
    }
    if (other.UseSsl != null) {
      this.UseSsl = other.UseSsl
    } else {
      this.UseSsl = null
    }
    if (other.Deprecated1 != null) {
      this.Deprecated1 = other.Deprecated1
    } else {
      this.Deprecated1 = null
    }
    if (other.SlowQueryLogThreshold != null) {
      this.SlowQueryLogThreshold = UInt64.fromNumber(other.SlowQueryLogThreshold)
    } else {
      this.SlowQueryLogThreshold = null
    }
    if (other.ArchiveDatabase != null) {
      this.ArchiveDatabase = StorageDatabaseType.fromObject(other.ArchiveDatabase)
    } else {
      this.ArchiveDatabase = null
    }
    if (other.ArchiveDatabaseFile != null) {
      this.ArchiveDatabaseFile = other.ArchiveDatabaseFile
    } else {
      this.ArchiveDatabaseFile = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!StorageServerSettings}
   * @returns {!StorageServerSettings} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new StorageServerSettingsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new StorageServerSettingsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!StorageServerSettings}
   * @param {!StorageServerSettings} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof StorageServerSettings)) {
      throw new TypeError('Instance of StorageServerSettings is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!StorageServerSettings}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      StoragePort: ((this.StoragePort != null) ? this.StoragePort : null),
      StorageDatabase: ((this.StorageDatabase != null) ? this.StorageDatabase : null),
      StorageDatabaseFile: ((this.StorageDatabaseFile != null) ? this.StorageDatabaseFile : null),
      UseSsl: ((this.UseSsl != null) ? this.UseSsl : null),
      Deprecated1: ((this.Deprecated1 != null) ? this.Deprecated1 : null),
      SlowQueryLogThreshold: ((this.SlowQueryLogThreshold != null) ? this.SlowQueryLogThreshold.toNumber() : null),
      ArchiveDatabase: ((this.ArchiveDatabase != null) ? this.ArchiveDatabase : null),
      ArchiveDatabaseFile: ((this.ArchiveDatabaseFile != null) ? this.ArchiveDatabaseFile : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return StorageServerSettings.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!StorageServerSettings} other Object value
   * @returns {!StorageServerSettings} Created struct
   */
  static fromObject (other) {
    return new StorageServerSettings().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!StorageServerSettings}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return StorageServerSettings.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!StorageServerSettings}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 11
  }
}

export { StorageServerSettings };

/**
 * Fast Binary Encoding StorageServerSettings field model
 */
class FieldModelStorageServerSettings extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.StoragePort = new fbe.FieldModelUInt16(buffer, 4 + 4)
    this.StorageDatabase = new FieldModelStorageDatabaseType(buffer, this.StoragePort.fbeOffset + this.StoragePort.fbeSize)
    this.StorageDatabaseFile = new fbe.FieldModelString(buffer, this.StorageDatabase.fbeOffset + this.StorageDatabase.fbeSize)
    this.UseSsl = new fbe.FieldModelBool(buffer, this.StorageDatabaseFile.fbeOffset + this.StorageDatabaseFile.fbeSize)
    this.Deprecated1 = new fbe.FieldModelBool(buffer, this.UseSsl.fbeOffset + this.UseSsl.fbeSize)
    this.SlowQueryLogThreshold = new fbe.FieldModelUInt64(buffer, this.Deprecated1.fbeOffset + this.Deprecated1.fbeSize)
    this.ArchiveDatabase = new FieldModelStorageDatabaseType(buffer, this.SlowQueryLogThreshold.fbeOffset + this.SlowQueryLogThreshold.fbeSize)
    this.ArchiveDatabaseFile = new fbe.FieldModelString(buffer, this.ArchiveDatabase.fbeOffset + this.ArchiveDatabase.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelStorageServerSettings}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelStorageServerSettings}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.StoragePort.fbeSize + this.StorageDatabase.fbeSize + this.StorageDatabaseFile.fbeSize + this.UseSsl.fbeSize + this.Deprecated1.fbeSize + this.SlowQueryLogThreshold.fbeSize + this.ArchiveDatabase.fbeSize + this.ArchiveDatabaseFile.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelStorageServerSettings}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.StoragePort.fbeExtra + this.StorageDatabase.fbeExtra + this.StorageDatabaseFile.fbeExtra + this.UseSsl.fbeExtra + this.Deprecated1.fbeExtra + this.SlowQueryLogThreshold.fbeExtra + this.ArchiveDatabase.fbeExtra + this.ArchiveDatabaseFile.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelStorageServerSettings}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelStorageServerSettings.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelStorageServerSettings}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 11
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelStorageServerSettings}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelStorageServerSettings}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.StoragePort.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StoragePort.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StoragePort.fbeSize

    if ((fbeCurrentSize + this.StorageDatabase.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StorageDatabase.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StorageDatabase.fbeSize

    if ((fbeCurrentSize + this.StorageDatabaseFile.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.StorageDatabaseFile.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StorageDatabaseFile.fbeSize

    if ((fbeCurrentSize + this.UseSsl.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.UseSsl.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.UseSsl.fbeSize

    if ((fbeCurrentSize + this.Deprecated1.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Deprecated1.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deprecated1.fbeSize

    if ((fbeCurrentSize + this.SlowQueryLogThreshold.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SlowQueryLogThreshold.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SlowQueryLogThreshold.fbeSize

    if ((fbeCurrentSize + this.ArchiveDatabase.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ArchiveDatabase.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ArchiveDatabase.fbeSize

    if ((fbeCurrentSize + this.ArchiveDatabaseFile.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ArchiveDatabaseFile.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ArchiveDatabaseFile.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelStorageServerSettings}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelStorageServerSettings}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelStorageServerSettings}
   * @param {!StorageServerSettings} fbeValue Default value, defaults is new StorageServerSettings()
   * @returns {!StorageServerSettings} StorageServerSettings value
   */
  get (fbeValue = new StorageServerSettings()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelStorageServerSettings}
   * @param {!StorageServerSettings} fbeValue StorageServerSettings value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.StoragePort.fbeSize) <= fbeStructSize) {
      fbeValue.StoragePort = this.StoragePort.get(6130)
    } else {
      fbeValue.StoragePort = 6130
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StoragePort.fbeSize

    if ((fbeCurrentSize + this.StorageDatabase.fbeSize) <= fbeStructSize) {
      fbeValue.StorageDatabase = this.StorageDatabase.get(new StorageDatabaseType(StorageDatabaseType.SQLITE))
    } else {
      fbeValue.StorageDatabase = new StorageDatabaseType(StorageDatabaseType.SQLITE)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StorageDatabase.fbeSize

    if ((fbeCurrentSize + this.StorageDatabaseFile.fbeSize) <= fbeStructSize) {
      fbeValue.StorageDatabaseFile = this.StorageDatabaseFile.get('../database/trader.db')
    } else {
      fbeValue.StorageDatabaseFile = '../database/trader.db'
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.StorageDatabaseFile.fbeSize

    if ((fbeCurrentSize + this.UseSsl.fbeSize) <= fbeStructSize) {
      fbeValue.UseSsl = this.UseSsl.get(false)
    } else {
      fbeValue.UseSsl = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.UseSsl.fbeSize

    if ((fbeCurrentSize + this.Deprecated1.fbeSize) <= fbeStructSize) {
      fbeValue.Deprecated1 = this.Deprecated1.get()
    } else {
      fbeValue.Deprecated1 = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deprecated1.fbeSize

    if ((fbeCurrentSize + this.SlowQueryLogThreshold.fbeSize) <= fbeStructSize) {
      fbeValue.SlowQueryLogThreshold = this.SlowQueryLogThreshold.get(new UInt64(100000000, 0))
    } else {
      fbeValue.SlowQueryLogThreshold = new UInt64(100000000, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SlowQueryLogThreshold.fbeSize

    if ((fbeCurrentSize + this.ArchiveDatabase.fbeSize) <= fbeStructSize) {
      fbeValue.ArchiveDatabase = this.ArchiveDatabase.get(new StorageDatabaseType(StorageDatabaseType.SQLITE))
    } else {
      fbeValue.ArchiveDatabase = new StorageDatabaseType(StorageDatabaseType.SQLITE)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ArchiveDatabase.fbeSize

    if ((fbeCurrentSize + this.ArchiveDatabaseFile.fbeSize) <= fbeStructSize) {
      fbeValue.ArchiveDatabaseFile = this.ArchiveDatabaseFile.get('../database/archive.db')
    } else {
      fbeValue.ArchiveDatabaseFile = '../database/archive.db'
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ArchiveDatabaseFile.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelStorageServerSettings}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelStorageServerSettings}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelStorageServerSettings}
   * @param {!StorageServerSettings} fbeValue StorageServerSettings value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelStorageServerSettings}
   * @param {StorageServerSettings} fbeValue StorageServerSettings value
   */
  setFields (fbeValue) {
    this.StoragePort.set(fbeValue.StoragePort)
    this.StorageDatabase.set(fbeValue.StorageDatabase)
    this.StorageDatabaseFile.set(fbeValue.StorageDatabaseFile)
    this.UseSsl.set(fbeValue.UseSsl)
    this.Deprecated1.set(fbeValue.Deprecated1)
    this.SlowQueryLogThreshold.set(fbeValue.SlowQueryLogThreshold)
    this.ArchiveDatabase.set(fbeValue.ArchiveDatabase)
    this.ArchiveDatabaseFile.set(fbeValue.ArchiveDatabaseFile)
  }
}

export { FieldModelStorageServerSettings };

/**
 * Fast Binary Encoding StorageServerSettings model
 */
class StorageServerSettingsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelStorageServerSettings(this.buffer, 4)
  }

  /**
   * Get the StorageServerSettings model
   * @this {!StorageServerSettingsModel}
   * @returns {!FieldModelStorageServerSettings} model StorageServerSettings model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!StorageServerSettingsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!StorageServerSettingsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return StorageServerSettingsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!StorageServerSettingsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelStorageServerSettings.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!StorageServerSettingsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!StorageServerSettingsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!StorageServerSettingsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!StorageServerSettingsModel}
   * @param {!StorageServerSettings} value StorageServerSettings value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!StorageServerSettingsModel}
   * @param {!StorageServerSettings} value StorageServerSettings value, defaults is new StorageServerSettings()
   * @return {!object} Deserialized StorageServerSettings value and its size
   */
  deserialize (value = new StorageServerSettings()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new StorageServerSettings(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new StorageServerSettings(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!StorageServerSettingsModel}
   * @param {!number} prev Previous StorageServerSettings model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { StorageServerSettingsModel };
